"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var react_1 = require("react");

exports.setFakeTokenContext = React.createContext(null);
exports.tokenContext = React.createContext(null);

exports.useSetFakeToken = function () {
  return react_1.useContext(exports.setFakeTokenContext);
};

exports.useToken = function () {
  return react_1.useContext(exports.tokenContext);
};

exports.useEmail = function () {
  return react_1.useContext(exports.tokenContext).content.email;
};

exports.useName = function () {
  return react_1.useContext(exports.tokenContext).content.name;
};